var React = require('react');

function Website (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2.026"},[React.createElement("path",{"d":"m22.3 12.1c0 5.6-4.5 10.1-10.1 10.1-5.7.1-10.2-4.5-10.2-10.1s4.5-10.1 10.1-10.1 10.2 4.5 10.2 10.1z","key":0}),React.createElement("path",{"d":"m12.0996 2v20.3","key":1}),React.createElement("path",{"d":"m20.9998 17h-17.7","key":2}),React.createElement("path",{"d":"m20.9998 7.30005h-17.7","key":3}),React.createElement("path",{"d":"m11.9998 2c-3.2 2.7-5.2 6.2-5.2 10.1s2 7.5 5.3 10.1","key":4}),React.createElement("path",{"d":"m12.0996 22.3001c3.3-2.7 5.3-6.2 5.3-10.1s-2-7.5-5.3-10.1","key":5}),React.createElement("path",{"d":"m22.3 12.1001h-20.3","key":6})]));
}

Website.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Website;

Website.default = Website;
